import Image from 'next/image'
import React, { useRef } from 'react'
import LazyLoad from 'react-lazy-load'
import H2El from '../../Elements/H2El/H2El'
import ParagraphEl from '../../Elements/ParagraphEl/ParagraphEl'
import ReadMoreBtnEl from '../../Elements/ReadMoreBtnEl/ReadMoreBtnEl'
import cx from 'classnames'
import styles from './ImageRow.module.css'
import { sharedData } from '../../Data/sharedData'
import imgCsrMobile from '../../../images/img-row-mobile.jpg'
import imgCSR from '../../../images/imgCSR.jpg'
import { useInView } from 'framer-motion'
import { imageBase64 } from '../../Data/blureBase64Image'

const ImageRow = () => {
  return (
    // <LazyLoad offset={200}>
    <div
      className={cx(
        styles.sliderContent,
        'w-100',
        'h-100',
        'position-relative'
      )}
    >
      <Image
        alt='CSR'
        src={imgCSR}
        className={cx(styles.mainImage, 'd-none', 'd-lg-flex')}
        width='100%'
        height='100%'
        placeholder='blur'
        loading='lazy'
        blurDataURL={imageBase64}
      />
      <Image
        width='100%'
        height='100%'
        alt='CSR'
        src={imgCsrMobile}
        className={cx(styles.mainImage, 'd-flex', 'd-lg-none')}
        placeholder='blur'
        loading='lazy'
        blurDataURL={imageBase64}
      />
      <div className={cx(styles.sliderOverlay, 'position-absolute')}></div>
      <div className={cx(styles.slidesInfo, 'position-absolute')}>
        <div className='w-100 d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between'>
          <div className='d-flex flex-column flex-xxl-row align-items-xxl-center align-items-start justify-content-center'>
            <div className='d-flex'>
              <H2El extraClasses={[styles.titleMarginBottom]}>
                مسئولیت اجتماعی
              </H2El>
            </div>
            <span
              className={cx(styles.verticalLine, 'd-xxl-flex', 'd-none')}
            ></span>
            <div className='d-flex'>
              <ParagraphEl extraClasses={[styles.paraMarginBottom]}>
                فرصت‌های جدید و خلاقانه برای همه؛ از توانمندسازی کسب‌وکارهای
                بومی محلی تا نیکوکاری شفاف و هدفمند
              </ParagraphEl>
            </div>
          </div>
          <div
            className='d-flex align-items-center justify-content-center'
            style={{ margin: '0px 30px' }}
          >
            <ReadMoreBtnEl
              btnTitle='بیشتر بخوانید'
              href={`https://about.digikala.com/digikalamehr/${sharedData.utmParams}`}
            />
          </div>
        </div>
      </div>
    </div>
    // </LazyLoad>
  )
}

export default ImageRow
